/** SPA navigate bridge for non-React modules (axios interceptors). */
let navigateFn = null;

export const setNavigate = (fn) => {
  navigateFn = fn;
};

export const appNavigate = (to, options) => {
  if (typeof navigateFn === 'function') {
    navigateFn(to, options);
    return;
  }
  if (typeof window !== 'undefined') {
    window.location.assign(to);
  }
};
